import { AxiosResponse, AxiosError } from 'axios';

/** An error thrown for a failed request, with the `code` from the response body when the API sent one */
export interface ResponseError extends Error {
  responseCode?: string;
}

const throwError = (code: number | string, message: string, responseCode?: string) => {
  const error: ResponseError = new Error(`${code}: ${message}`);
  error.responseCode = responseCode;
  throw error;
};

export const handleError = (error: AxiosError) => {
  return error.response
    ? throwError(
        error.response.status,
        typeof error.response.data === 'string' ? error.response.data : error.response.data.message,
        typeof error.response.data === 'string' ? undefined : error.response.data.code
      )
    : throwError('Uncaught', error.message);
};

export const oneData = <T>(res: AxiosResponse<T>) => (Array.isArray(res.data) ? res.data[0] : res.data);

export const allData = <T>(res: AxiosResponse<T>) => res.data;

export const getErrorCode = (err: Error) => {
  // get all digits matching within the message
  const extractedCode = err.message.match(/^\d+/g);
  return extractedCode && Number(extractedCode.join(''));
};

/** Returns the `code` from the response body (e.g. CONFIGURATION_IN_USE_BY_KIOSK), unlike getErrorCode which returns the HTTP status */
export const getResponseErrorCode = (err: Error) => (err as ResponseError).responseCode;

export const getErrorMessage = (err: Error, returnFull?: boolean) => {
  const splitMessage = err.message.split(': ');
  if (returnFull) {
    return splitMessage.slice(1, splitMessage.length).join(': ');
  }
  return splitMessage.length > 1 ? splitMessage[1] : splitMessage[0];
};
